import { useParams } from 'react-router-dom';
import { Layout } from '../layouts/Layout';
import { Sidebar } from '../components/Sidebar';
import { Header } from '../components/Header';
import EmployeeForm from '../components/EmployeeForm';

/**
 * EmployeeEdit page component
 * Displays the employee edit form wrapped in the application layout
 * Extracts employee ID from URL parameters
 */
export default function EmployeeEdit() {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return (
      <Layout>
        <Sidebar />
        <div className="md:ml-64">
          <Header />
          <main className="p-6">
            <div className="flex items-center justify-center min-h-screen">
              <div className="text-center">
                <p className="text-red-600">Invalid employee ID</p>
              </div>
            </div>
          </main>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <Sidebar />
      <div className="md:ml-64">
        <Header />
        <main className="p-6">
          <EmployeeForm mode="edit" employeeId={id} />
        </main>
      </div>
    </Layout>
  );
}
